import React, {memo} from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'

import {ReactComponent as DesignIcon} from '../assets/images/icons/design-feature.svg'
import {ReactComponent as DevelopIcon} from '../assets/images/icons/develop-feature.svg'
import {ReactComponent as LaunchIcon} from '../assets/images/icons/launch-feature.svg'
import {ReactComponent as PromoteIcon} from '../assets/images/icons/promote-feature.svg'
import {ReactComponent as SupportIcon} from '../assets/images/icons/support-feature.svg'
import ScrollAnimation from './ScrollAnimation'
import './Services.scss'

const features = [
  {
    id: 1,
    title: 'design',
    Icon: DesignIcon,
    text: 'We design the most effective user interface to highlight your business in the best possible way.',
  },
  {
    id: 2,
    title: 'develop',
    Icon: DevelopIcon,
    text: 'We use the right technologies to achieve the best results. Our code is easy to maintain and support.',
  },
  {
    id: 3,
    title: 'launch',
    Icon: LaunchIcon,
    text: 'We do everything required to get your website launched with all tracking and analytics tools installed.',
  },
  {
    id: 4,
    title: 'promote',
    Icon: PromoteIcon,
    text: 'We employ the most effective digital marketing strategies to promote your business.',
  },
  {
    id: 5,
    title: 'support',
    Icon: SupportIcon,
    text: 'We provide continuous support after launch. We update code to comply with the latest standards.',
  },
]

Services.propTypes = {
  width: PropTypes.string.isRequired,
}

function Services({width}) {
  const renderedFeatures = features.map((feature, index) => (
    <li key={feature.id} className="Services-Item">
      <ScrollAnimation
        className="Services-ItemBlock"
        effect={
          width === 'sm' ? 'growServicesBlockInSm' : width === 'xs' ? 'growServicesBlockInXs' : 'growServicesBlockIn'
        }
        delay={width === 'xs' ? 0 : index * 300}
      />
      <div className="Services-ItemContent">
        <ScrollAnimation
          className="Services-ItemIconBlock"
          effect={index % 2 === 0 ? 'scaleIn' : 'scaleOut'}
          delay={width === 'xs' ? 0 : index * 200}
        >
          <feature.Icon className="Services-ItemIcon" />
        </ScrollAnimation>
        <ScrollAnimation effect="fadeInRight" delay={width === 'xs' ? 0 : index * 200}>
          <h3 className="Services-ItemTitle">{feature.title}</h3>
          <p className="Services-ItemText">{feature.text}</p>
        </ScrollAnimation>
      </div>
    </li>
  ))
  return (
    <ScrollableAnchor id="services">
      <section className="Services">
        <div className="Services-Background" />
        <div className="Services-Container Container">
          <Grid container spacing={2}>
            <Hidden mdDown>
              <Grid item xs={1} />
            </Hidden>
            <Grid item xs={12} sm={9} md={7} lg={5}>
              <ScrollAnimation tag="h2" className="Services-Title Title" effect="fadeInTop">
                Services
              </ScrollAnimation>
              <ScrollAnimation tag="p" className="Services-Attention" effect="fadeInLeft">
                <b>– we have you covered</b>
              </ScrollAnimation>
              <ScrollAnimation tag="p" className="Services-Text" effect="fadeInBottom">
                Our goal is look after all aspects of your digital representation including brand refresh, website
                design, build, release, hosting, digital marketing and support. You can focus on your business and we
                will take care of the rest.
              </ScrollAnimation>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Hidden mdDown>
              <Grid item xs={1} />
            </Hidden>
            <Grid item md={12} lg={10}>
              <ul className="Services-List">{renderedFeatures}</ul>
            </Grid>
            <Hidden mdDown>
              <Grid item xs={1} />
            </Hidden>
          </Grid>
        </div>
      </section>
    </ScrollableAnchor>
  )
}

export default memo(Services)
